{
  "url.connect": "/connexion",
  "url.donate": "/faire-un-don",
  "url.community": "/communaute/{id}-{slug}",
  "url.menu.events": "/page/evenements",
  "url.menu.contact": "/nous-contacter",
  "url.menu.introduction": "/page/introduction",
  "url.menu.about": "/page/about",
  "url.menu.communities-list": "/liste-communautes",
  "url.menu.guides-list": "/guides-list",
  "url.menu.cgu": "/page/cgu"
}
